import { LOT_NUMBER_LABEL } from '@constants/ssap/miscellaneous/miscellaneous';

const hasLotNumberPrefix = value => !!value && value.trim().toLowerCase().startsWith(LOT_NUMBER_LABEL.toLowerCase());

// Adds the "Lot Number " prefix (used right before saving) so it is persisted
// even if the consumer only typed the lot number itself. Consumers are also
// free to type "Lot Number" themselves, in which case it is left as-is.

const addLotNumberPrefix = value => {
    if(!value || hasLotNumberPrefix(value)) {
        return value;
    }

    return `${LOT_NUMBER_LABEL} ${value}`;
};

export const lotNumberTools = {
    addLotNumberPrefix
};
